import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from "react-router-dom";

// import VideoThumbnail from '../../Assets/Images/video-thumbnail.png';
import videoThumbnail from '../../Assets/Images/thumbnail.png';
import ImgLeft from '../../Assets/Images/thumbnail.png';
// import videoThumbnailMobile from '../Assets/Images/video-thumbnail-mobile.png';
// import playButton from '../Assets/Images/play-button.png';
import playBtnImg from '../../Assets/Images/play-btn.png';
import playBtnHoverImg from '../../Assets/Images/play-btn-hover.png';
import clockImg from '../../Assets/Images/clock-icon.svg';
import { Close } from "@mui/icons-material";
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import { Button } from '@mui/material';

const StartIndividual = props => {

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { windowWidth } = useWindowDimensions();

  const [isLoading, setIsLoading] = useState(true);
  const [playingVideo, setPlayingVideo] = useState(false);
  const [startPlaying, setStartPlaying] = useState(false);
  const [playBtn, setPlayBtn] = useState(playBtnImg);

  const vidRef = useRef(null);
  const introElmRef = useRef(null);
  const videoElmRef = useRef(null);

  const display = searchParams.get("display");


  // useEffect(() => {
  //   if (windowWidth <= 550) {
  //     document.body.style.background = `linear-gradient(180deg, #172D43 0%, rgba(39, 80, 120, 0.9) 75%, #343333 75%, #343333 100%)`;
  //   } else {
  //     document.body.style.background = `linear-gradient(180deg, #172D43 0%, rgba(39, 80, 120, 0.9) 100%)`;
  //   }
  // }, [windowWidth]);

  // useEffect(() => {
  //   if(display === "preview") {
  //     console.log("changed background img for embedded preview display...");
  //     document.body.style.background = `#242424 url(${introBgImg}) repeat`;
  //   } else {
  //     document.body.style.background = `#414042`;
  //   }
  // }, [display]);

  const createAssessment = () => {

    let leaderId = 0;
    let userId = 0;
    let isMember = false;
    if (searchParams?.get("leader")) {
      leaderId = searchParams?.get("leader");
      userId = searchParams?.get("user");
      isMember = true;
    }

    const clientId = process.env.REACT_APP_CLIENT_ID;
    fetch(process.env.REACT_APP_API_URI + '/v3/user/assessment', {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientId, isMember, leaderId, userId })
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.status === "success") {
        const assessmentName = localStorage.getItem("assessmentName");
        navigate(`/explainer/${data.id}?${searchParams}`, { replace: true });
        // navigate(`/${assessmentName}/assessment/` + data.id + "/815?" + searchParams, { replace: true });
        console.log("data", data);
      } else {
        // setIsSaving(false);
        // setOpenSnackbar(true);
      }
    }).catch((err) => console.error("Failed to create new assessment...", err));
  }


  const howItWorksLink = () => {
    if (searchParams == "") {
      return "/how-it-works";
    } else {
      return "/how-it-works?" + searchParams;
    }
  }
  // console.log(searchParams.get("display"));

  const assessmentLink = () => {
    // return "/assessment?" + searchParams;
    // navigate("/assessment?" + searchParams);
    createAssessment();
  }

  const preAssessmentQuestionsLink = () => {
    navigate("/pre-additional-questions?" + searchParams);
  }

  const introPageLink = () => {
    createAssessment();
    // navigate("/intro/" + id + "?" + searchParams);
  }

  const playVideo = (e) => {

    if (windowWidth > 830) {
      const introElm = introElmRef.current;
      const videoElm = videoElmRef.current;

      introElm.style.cssText = "width: 0%; padding: 0; overflow: hidden;"
      videoElm.style.cssText = "width: 100%; margin: 0 auto; background-color: #0E435C; border-radius: 0;";
      // if(display === "preview") {
      //   videoElm.style.background = `#242424 url(${introBgImg}) repeat`;
      // } else videoElm.style.backgroundColor = "#435B63";
    }
    vidRef.current.play();
    setPlayingVideo(true);
    if (!startPlaying) {
      setStartPlaying(true);
    }
  }

  const pauseVideo = (e) => {
    // vidRef.current.pause();
    // setPlayingVideo(false);
    vidRef.current.pause();

    if (windowWidth > 830) {
      const introElm = introElmRef.current;
      const videoElm = videoElmRef.current;

      introElm.style.cssText = "width: 50%; padding: 20px 5%; overflow: hidden;";
      videoElm.style.cssText = "width: 50%; margin: 0 auto; background-color: #0E435C; border-top-left-radius: 10px; border-bottom-left-radius: 10px;";
      // if(display === "preview") {
      //   videoElm.style.background = `#242424 url(${introBgImg}) repeat`;
      // } else videoElm.style.backgroundColor = "#435B63";
    }
    setPlayingVideo(false);
  }

  const handleVideoPlaybackEnd = () => {
    setPlayingVideo(false);

    if (windowWidth > 830) {
      const introElm = introElmRef.current;
      const videoElm = videoElmRef.current;

      introElm.style.cssText = "width: 50%; padding: 20px 5%; overflow: hidden;";
      videoElm.style.cssText = "width: 50%; margin: 0 auto; background-color: #0E435C; border-top-left-radius: 10px; border-bottom-left-radius: 10px;";

      // if(display === "preview") {
      //   videoElm.style.background = `#242424 url(${introBgImg}) repeat`;
      // } else videoElm.style.backgroundColor = "#435B63";
    }
    showThumbnail();
    showPlayButton();
  }

  const showThumbnail = () => {
    if (playingVideo) {
      return <img alt="video thumbnail" className="thumbnail" src={videoThumbnail} style={{ opacity: '0' }} onClick={(e) => pauseVideo(e)} />;
    } else {
      if (startPlaying) {
        return null
      } else {
        return <img alt="video thumbnail" className="thumbnail" src={videoThumbnail} />
      }
    }
  }

  const showPlayButton = () => {
    if (playingVideo) {
      return null
    } else {
      return <img alt="play button" className="playbtn" src={playBtn}
        onMouseOver={() => setPlayBtn(playBtnHoverImg)}
        onMouseOut={() => setPlayBtn(playBtnImg)}
        onClick={(e) => playVideo(e)} />;
    }
  }


  const vidsrcURL = "https://40parables-assets.s3.amazonaws.com/Guest-Ready-Intro-Video.mp4";

  return (
    <>
      {/* <div className='intro'>
        <h3>If you were at our service, we'd love to hear from you!</h3>
      </div>
    <div className='main-container'>
      <div className="container start"> */}
      {/* <div className="video" ref={videoElmRef}>
        <video ref={vidRef} onEnded={handleVideoPlaybackEnd}>
          <source src={vidsrcURL} type="video/mp4" />
        </video>
        {showThumbnail()}
        {showPlayButton()}

        {playingVideo && <Close className="close-video" style={{
          position: "absolute", height: "20px", width: "20px", color: "#fefefebb", opacity: 0.75, zIndex: 99, padding: "15px", top: "5px", cursor: "pointer",
          right: windowWidth > 1100 ? "70px" : "5px"
        }} onClick={(e) => pauseVideo(e)} />}

      </div> */}
      {/* { windowWidth < 550 ? 
        <div style={{ width: '100%', height: '12px', backgroundColor: '#0E435C'}}></div> : <div></div>
      } */}
      {/* <div className="intro" ref={introElmRef}>
        <h1>How effective is your <br></br> marriage ministry strategy?</h1>
        <p className='intro-para'>See how you compare* with similarly-sized American churches</p>
        <div className="completion">See how you compare* with similarly-sized American churches</div>
        <ol className="intro-points-list">
          {searchParams.get("leader") ? <>
            <li>Take this 3-minute assessment</li>
            <li>View your results instantly</li>
            <li>Align on the best next step for your ministry</li>
          </> : <>
            <li>Take this 3-minute assessment</li>
            <li>Invite your team to take it, too, after you do</li>
            <li>View everyone's results on one dashboard</li>
            <li>Align on the best next step for your ministry</li>
            <li>Find out how your church is faring in 5 critical areas of generosity.</li>
          </>}
        </ol>

        <div className="completion">
          <div className='btn-container'>
          <Link to={assessmentLink()} className="cta">Get Started</Link>
          <Button className="cta" onClick={createAssessment}>TEST AND SEE</Button>
          </div>
          <div className=''>
            <div className='img-container'><img className='clock-icon' src={clockImg} alt="estimated time" /></div><span style={{ margin: "auto" }}>{searchParams.get("leader") ? "3 min" : "3 min"}</span>
          </div>
        </div>


        <div className='para-container'>
          <p className='para'>*We can help you compare your church's data to that of about 10,000 churches
          in the US through our church engagement research.</p>
        </div>
      </div> */}
      {/* <div className='contents'>
        <p>Please share your feedback on this 30-second survey.</p>
        <div className="completion">
          <div className='btn-container'>
            <Button onClick={() => assessmentLink()} className="cta">Get Started!</Button>
          </div>
          <div className='time-estimate'>
            <div className=''><img className='clock-icon' src={clockImg} alt="estimated time" /></div><span >30 seconds</span>
          </div>
        </div>
      </div>
      </div>
    </div> */}
      <div className="start-page">
        <div className="image-left">
          <img src={ImgLeft} alt="left img" />
        </div>
        <div className="content-right">
          <h1 className="title">Find your POTENTIAL</h1>
          <div className="intro-paragraph">
            <p>Heart, Soul, Mind and Strength, are 4 core quadrants that make us human. Explore how you flow now!</p>
          </div>
          <div className='list'>
            <ol>
              <li>Take this 7-minute assessment</li>
              <li>Identify your key quadrants</li>
              <li>Discover your potential</li>
              <li>Unlock your strengths</li>
              <li>View your results instantly</li>
            </ol>
          </div>
          <div className="cta-container">
            <Button  className="cta" onClick={() => assessmentLink()} >Get Started</Button>
            {/* <div className='time-estimate'>
              <div className=''><img className='clock-icon' src={clockImg} alt="estimated time" /></div><span>7 min</span>
            </div> */}
          </div>
        </div>
      </div>
    </>

  );
}

export default StartIndividual;
